// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cc6f3822","455":"8cc4f789","977":"8d8a6de1"}[chunkId] + ".chunk.js";
};